/**
 * Simple Text Block JavaScript
 */

(function () {
	'use strict';

	function initSimpleText() {
		document.querySelectorAll('.simple-text').forEach((block) => {
			// Add your block functionality here
		});
	}

	function onReady() {
		if (document.querySelector('.simple-text')) {
			initSimpleText();
		}
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', onReady);
	} else {
		onReady();
	}
})();
